/**
 * @Description: 路由配置
 * @Date: 2019-8-13
 * @Modify:
 * @Author: kerong
 */
/* Layout */
import Layout from '@/components/layout/Index'

export default [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index'),
    hidden: true,
    meta: { title: '首页', icon: 'workbench', noCache: true, keepAlive: false, auth: true }
  },
  {
    path: '/workbench',
    component: Layout,
    redirect: '/workbench/index',
    children: [
      {
        path: 'index',
        // component: () => import('@/views/home/IndexNew'),
        component: () => import('@/views/workbench/index'),
        name: 'Workbench',
        meta: { title: '工作台', icon: 'workbench', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'qysjkb',
        // component: () => import('@/views/home/IndexNew'),
        component: () => import('@/views/workbench/component/data-panel.vue'),
        name: 'Workbench',
        meta: { title: '企业数据看板', icon: 'workbench', noCache: true, keepAlive: false, auth: true }
      },
      {
        path: 'yggzmb',
        // component: () => import('@/views/home/IndexNew'),
        component: () => import('@/views/workbench/component/employee-panel.vue'),
        name: 'Workbench',
        meta: { title: '员工数据看板', icon: 'workbench', noCache: true, keepAlive: false, auth: true }
      }
    ]
  },
  {
    path: '/importPersonalData',
    component: () => import('@/components/layout/components/ImportPersonalAccount.vue'),
    name: 'ImportPersonalData',
    meta: { title: '导入个人账号资料', icon: 'workbench', noCache: true, keepAlive: false, auth: true }
  },
  {
    path: '/cfmcc/*',
    component: Layout
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
  // { path: '*', redirect: '/404', hidden: true }
]
